<script>
import Layout from "../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "../../../../app.config";
import { required } from "vuelidate/lib/validators";
import CheckModal from "@/components/CheckModal";
import CustodiaHistoriasAPI from "@/services/standards/custodiaHistorias/custodiaHistoriasAPI";
import Table from "@/components/standard/Induction/components/InductionTable";
import ItemAPI from "@/services/items/itemsAPI";

/**
 * Basic Tables component
 */
export default {
  page: {
    title: "3.1.5 Custodia de historias clínicas ocupacionales",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Style,
    PageHeader,
    Table,
    CheckModal,
  },
  data() {
    return {
      title: "3.1.5 Custodia de historias clínicas ocupacionales",
      items: [
        {
          text: "Estándares",
          href: "/forms/estandares",
        },
        {
          text: "Custodia de historias clínicas ocupacionales",
          href: `/forms/estandares/${this.$store.getters["company/getCompany"].id || null
            }/custodia-historias`,
        },
        {
          text: "Ver",
          active: true,
        },
      ],
      list: [],
      themes: [],
      search: null,

      file: null,
      file2: null,

      custodia: {
        application_date: null,
        provider_evaluations: null,
        certificate: null,
        security_license: null,
        observations: null,
        companies_id: this.$store.getters["company/getCompany"].id || null,
      },

      submitted: false,

      company: null,

      companyID: this.$store.getters["company/getCompany"].id || null,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      user: this.$store.state.auth || null,

      loading1: true,
      item: null,
      itemData: null,
    };
  },
  validations: {
    file: {
      required,
    },

    custodia: {
      provider_evaluations: {
        required,
      },
      application_date: {
        required,
      },
    },
  },
  methods: {

    getItemData() {
      ItemAPI.getItems(27)
        .then((response) => {
          this.itemData = response;
          this.loading1 = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    /**
     * This method is used to redirect to the page indicated
     * @param {String} page The page to redirect
     */
    goPage(page) {
      window.location.href = page;
    },

    getShow() {
      CustodiaHistoriasAPI.getShow(this.$route.params.id)
        .then((response) => {
          this.custodia = {
            application_date: response.data.application_date,
            provider_evaluations: response.data.provider_evaluations,
            certificate: response.data.certificate,
            security_license: response.data.security_license,
            observations: response.data.observations,
            companies_id: response.data.companies_id,
          };
          this.loading1 = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    gotoDigitalOcean(url) {
      window.open(url);
    },

    goBack() {
      this.$router.go(-1);
    },

  },

  mounted() {
    this.getShow();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-lg-12">
        <div v-if="!loading1">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-12 text-right m-b-0">
                  <div class="btn btn-secondary m-l-5 ml-1" id="back" @click="goBack">
                    <i class="fas fa-arrow-left"></i>
                  </div>
                  <b-tooltip target="back" placement="left"> Volver </b-tooltip>
                </div>
              </div>
              <hr />
              <form class="form-group" @submit.prevent="save">
                <div class="form-row col-12 pt-2">
                  <b-form-group class="col-md-6 px-2" label="Fecha solicitud certificado" label-for="trainingDate">
                    <b-form-input type="date" v-model="custodia.application_date" :class="{
                      'is-invalid':
                        $v.custodia.application_date.$error && submitted,
                    }" id="trainingDate" disabled>
                    </b-form-input>
                  </b-form-group>

                  <b-form-group class="col-md-6 px-2" label="Proveedor evaluaciones médicas" label-for="trainingDate">
                    <b-form-input type="text" v-model="custodia.provider_evaluations" id="trainingDate" disabled>
                    </b-form-input>
                  </b-form-group>
                </div>
                <div class="form-row col-12">
                  <b-form-group class="col-md-12 px-2" label="Observaciones" label-for="description">
                    <b-form-textarea disabled id="description" v-model="custodia.observations" maxlength="200">
                    </b-form-textarea>
                  </b-form-group>
                </div>
                <div class="form-row col-12 pt-2">
                  <b-form-group class="col-md-6 px-2 text-center"
                    label="Certificado de la custodia de la historia clínica" label-for="evidence">
                    <div v-if="custodia.certificate === null">
                      <h6>No hay archivo disponible</h6>
                    </div>
                    <div v-else class="d-flex justify-content-center">
                      <button style="
                          background-color: transparent !important;
                          border: none;
                        " type="button" @click="gotoDigitalOcean(`${custodia.certificate}`)">
                        <i class="mdi mdi-cloud-download"></i>
                      </button>
                    </div>
                  </b-form-group>
                  <b-form-group class="col-md-6 px-2 text-center"
                    label="Licencia en seguridad y salud en el trabajo del médico" label-for="evidence">
                    <div v-if="custodia.security_license === null">
                      <h6>No hay archivo disponible</h6>
                    </div>
                    <div v-else class="d-flex justify-content-center">
                      <button style="
                          background-color: transparent !important;
                          border: none;
                        " type="button" @click="
                          gotoDigitalOcean(`${custodia.security_license}`)
                          ">
                        <i class="mdi mdi-cloud-download"></i>
                      </button>
                    </div>
                  </b-form-group>
                </div>

              </form>
            </div>
          </div>
        </div>

        <div v-else>
          <div class="text-center">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
          </div>
        </div>

        <!-- end card -->
      </div>
    </div>
    <!--- end row -->
  </Layout>
</template>

<style scoped>
.background-modal {
  background-color: transparent !important;
  border: none;
}
</style>
